module.exports = __webpack_public_path__ + "assets/c20427eae12ee7b8d93110b969b660b1.svg";